module.exports = __webpack_public_path__ + "assets/images/nn-square.98114327e95611851fa0e14c257bfa22.png";